const privacyPolicy = [
    { 
        id: "overview", 
        title: "1. Overview", 
        content: [
            "At Siraj Islamic Center, we value the privacy of our community members and are committed to protecting the information entrusted to us.",
            "This Privacy Policy outlines how we collect, use, and safeguard your personal information when you engage with our website, programs, and services.",
            "By participating in our activities or using our online resources, you agree to the terms of this Privacy Policy."
        ]
    },
    {
        id: "data-privacy", 
        title: "2. Data Privacy", 
        content: [
            "We collect personal and non-personal information to better serve our community and manage our programs effectively.",
            "The information we collect may include, but is not limited to:"
        ],
        list: [
            "Full name, contact details, and registration information",
            "Details for event or program participation",
            "Donation records and payment information",
            "Feedback and communication with our administrative team"
        ]
    },
    { 
        id: "terms-of-service", 
        title: "3. Terms of Service", 
        content: [
            "Our Terms of Service govern the use of the Siraj Islamic Center website, facilities, and community services.",
            "By accessing our resources or attending our programs, you agree to abide by these terms, which include respectful use, community conduct, and adherence to Islamic values."
        ]
    },
    { 
        id: "user-rights", 
        title: "4. User Rights", 
        content: [
            "As a member or participant, you have rights regarding your personal information, including:"
        ],
        list: [
            "Right to access, update, or request deletion of your personal information",
            "Right to withdraw consent for information use at any time",
            "Right to correct inaccurate or incomplete information"
        ]
    },
    { 
        id: "data-security", 
        title: "5. Data Security", 
        content: [
            "We use secure and trusted systems to protect your personal information from unauthorized access, misuse, or disclosure.",
            "This includes encryption, secure servers, and restricted access to sensitive information."
        ]
    },
    { 
        id: "cookies", 
        title: "6. Cookies", 
        content: [
            "Our website may use cookies and similar tools to enhance your browsing experience and improve website performance.",
            "Cookies help us tailor content and ensure smooth access to our online resources."
        ]
    },
    { 
        id: "third-party", 
        title: "7. Third-Party Services", 
        content: [
            "We may partner with trusted third parties for payment processing, event management, or technical support.",
            "These partners follow their own privacy policies, and we encourage reviewing their terms when applicable."
        ]
    },
    { 
        id: "data-storage", 
        title: "8. Data Storage", 
        content: [
            "Your information is securely stored in compliance with privacy laws and best practices.",
            "We retain information only for as long as necessary to provide our services or meet legal obligations."
        ]
    },
    { 
        id: "data-transfers", 
        title: "9. Data Transfers", 
        content: [
            "If your information is stored or processed outside your country, we ensure it is handled securely and in accordance with relevant privacy regulations."
        ]
    },
    { 
        id: "policy-updates", 
        title: "10. Policy Updates", 
        content: [
            "We may update this Privacy Policy to reflect changes in our services, technology, or legal requirements.",
            "The latest version will always be available on our website."
        ]
    }
];

export default privacyPolicy;